import { ApolloCache } from '@apollo/client';
import {
  DashboardListItemViewFragmentDoc,
  DashboardViewFragment,
  DashboardViewFragmentDoc,
  DashboardUseCase,
} from 'generated/graphql';

export const cacheDashboardListItemMaybe = (
  cache: ApolloCache<unknown>,
  id: string,
) => {
  const dashboardListItem = cache.readFragment({
    id:
      cache.identify({
        __typename: 'DashboardListItem',
        id,
      }) ?? '',
    fragment: DashboardListItemViewFragmentDoc,
    fragmentName: 'DashboardListItemView',
  });
  if (dashboardListItem) {
    return true;
  }

  const dashboard: DashboardViewFragment | null = cache.readFragment({
    id:
      cache.identify({
        __typename: 'Dashboard',
        id,
      }) ?? '',
    fragment: DashboardViewFragmentDoc,
    fragmentName: 'DashboardView',
  });
  if (!dashboard) {
    return false;
  }

  const dashboardListItemFragmentData = {
    __typename: 'DashboardListItem',
    id: dashboard.id,
    tenantID: dashboard.tenantID,
    title: dashboard.title,
    viewToken: dashboard.viewToken,
    editToken: dashboard.editToken,
    scope: dashboard.scope,
    createdAt: dashboard.createdAt,
    createdBy: dashboard.createdBy,
    analysisIDs: dashboard.analyses?.map(({ id }) => id),
    recency: dashboard.updatedAt,
    useCase: DashboardUseCase.Default,
    shortMetadata: dashboard.shortMetadata,
  };

  cache.writeFragment({
    id:
      cache.identify({
        __typename: 'DashboardListItem',
        id,
      }) ?? '',
    fragment: DashboardListItemViewFragmentDoc,
    fragmentName: 'DashboardListItemView',
    data: dashboardListItemFragmentData,
  });

  return true;
};
